import { cn } from '@/lib/utils/cn';
import type { TutorialPersona } from '../data/tutorial-data';

interface StoryHeaderProps {
  persona: TutorialPersona | null;
  quote: string;
  children?: React.ReactNode;
}

export function StoryHeader({ persona, quote, children }: StoryHeaderProps) {
  return (
    <div className="mb-6">
      {persona ? (
        <div className="flex items-start gap-4">
          <div
            className={cn(
              'flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg',
              persona.color
            )}
          >
            {persona.initials}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <span className="font-semibold">
                {persona.name} {persona.lastName}
              </span>
              <span className={cn('text-xs px-2 py-0.5 rounded-full text-white', persona.color)}>
                {persona.roleLabel}
              </span>
            </div>
            <blockquote className="text-muted-foreground italic border-l-2 border-primary/30 pl-3 text-sm">
              "{quote}"
            </blockquote>
          </div>
        </div>
      ) : (
        <p className="text-muted-foreground text-sm">{quote}</p>
      )}
      {children}
    </div>
  );
}
